import { Table } from '@molecules';
import { useNewsWireManager } from 'src/features/Enterprise/NewsWire/AddNewsWireModal/useNewsWire';
import { getNewsWireTableColumns } from 'src/features/Enterprise/NewsWire/newsWireTable.config';
import {
  FILTERS_LIST_NEWS_WIRE,
  TableEnterpriseNewsWire,
} from '../../../features/Enterprise/NewsWire/constants';
import { AddNewsWireModal } from 'src/features/Enterprise/NewsWire/AddNewsWireModal/AddNewsWireModal';
import { useParams } from 'react-router-dom';
import { ApiClientEnterprise } from '@helpers/apiClients';
import QueryKeys from '@constants/query-keys';
import { ConfirmModal } from '@organisms';
import { DeleteModalIcon } from '@atoms/Icons/DeleteModalIcon';
import { Typography } from '@mui/material';
import { useModalState } from '@hooks';

const EnterpriseNewsWire = () => {
  const { id: organizationId } = useParams<{ id: string }>();

  const { defaultItem, isOpen, openModal, onClose, editingItem, setEditingItem, onEdit, onDelete } =
    useNewsWireManager();
  const [isConfirmDelete, , openConfirmDeleteModal, closeConfirmDeleteModal] = useModalState(false);

  const onClickEdit = (item: TableEnterpriseNewsWire) => {
    onEdit(item);
    openModal();
  };

  const onClickDelete = (item: TableEnterpriseNewsWire) => {
    setEditingItem(item);
    openConfirmDeleteModal();
  };

  const onCloseConfirmationDeleteModal = () => {
    setEditingItem(defaultItem);
    closeConfirmDeleteModal();
  };

  const onSubmitDelete = () => {
    onDelete(editingItem);
    closeConfirmDeleteModal();
  };

  return (
    <>
      <Table<TableEnterpriseNewsWire>
        searchPlaceholder="Search for News"
        columns={getNewsWireTableColumns({ onClickEdit, onClickDelete })}
        filtersList={FILTERS_LIST_NEWS_WIRE}
        apiClient={ApiClientEnterprise}
        rowsPerPageOptions={[10, 20, 50, 100, 200]}
        pinnedColumns={{
          left: ['__check__', 'title'],
          right: ['action'],
        }}
        apiRoute={`/enterprises-admin/${organizationId}/newswire`}
        queryName={QueryKeys.enterpriseNewsWire}
        usingIsFetching
        customSxForTable={{
          '& .MuiDataGrid-columnSeparator': {
            display: 'contents !important',
            '& svg': {
              pointerEvents: 'initial',
            },
          },
        }}
      />
      <AddNewsWireModal
        open={isOpen}
        onClose={onClose}
        title="Edit newswire"
        subtitle="Here you can edit newswire"
        editingItem={editingItem}
      />
      <ConfirmModal
        open={isConfirmDelete}
        onCancel={onCloseConfirmationDeleteModal}
        onSubmit={onSubmitDelete}
        icon={<DeleteModalIcon width={55} height={71} />}
        title={
          <Typography
            sx={{
              fontSize: '24px',
              lineHeight: '20px',
              color: '#464F6080',
              whiteSpace: 'normal',
              marginBottom: '-8px',
            }}
          >
            Are you sure you want to delete this item?
          </Typography>
        }
        submitText="Delete"
        submitColor="error"
        usingModalV2
      />
    </>
  );
};

export default EnterpriseNewsWire;
